// extracted by mini-css-extract-plugin
export default {"gif":"x_ck","gif--wrapped":"x_cl"};